import React, { useEffect, useRef } from "react";
import styles from "./UploadImage.module.css";
import uploadImage from "../../assets/componentAssets/uploadImage.svg";

function UploadImage({
  getImage = () => {},
  img = "",
  imgs,
  accept = "image/*",
  ...props
}) {
  const fileInputRef = useRef(null);

  const handleFile = (file) => {
    if (file) getImage(file);
  };

  const handleImageChange = (event) => {
    handleFile(event.target.files && event.target.files[0]);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    handleFile(event.dataTransfer.files && event.dataTransfer.files[0]);
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleClick = () => {
    if (!fileInputRef.current) return;
    // Allow selecting the same file twice in a row
    fileInputRef.current.value = "";
    fileInputRef.current.click();
  };

  useEffect(() => {
    // When parent clears the selection, also clear the underlying file input
    if (!imgs && fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  }, [imgs]);

  return (
    <div
      className={styles.imageUploadContainer}
      style={{
        background: "white",
        border: `2px dashed #22A156`,
        borderRadius: "10px",
      }}
      onClick={handleClick}
      onDrop={handleDrop}
      onDragOver={handleDragOver}
    >
      <input
        type="file"
        accept={accept}
        onChange={handleImageChange}
        ref={fileInputRef}
        style={{ display: "none" }}
      />
      <div className={styles.uploadArea}>
        {/* {!image ? (
          selectedImage ? (
            <img src={selectedImage} alt="Uploaded Preview" />
          ) : ( */}
        <div>
          <img src={uploadImage} alt="" />
          <p>Drag & Drop or Upload</p>
        </div>
        {/* )
        ) : (
          <img src={img} style={{ width: "auto", height: "auto" }} />
        )} */}
      </div>
    </div>
  );
}

export default UploadImage;
